/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="screencontrollerbase.ts" />

module App.Common.Controllers {
	'use strict';

	export abstract class SectionScreenControllerBase extends ScreenControllerBase {

		public static $inject = [
			'$injector'
		];

		constructor($injector: angular.auto.IInjectorService) {
			super($injector);
			this.instructionId = this.$stateParams['id'];
		}

		public instructionId: any;

	}

}